import {
  Dialog,
  DialogContent as DSDialogContent,
  DialogActions as DSDialogActions,
  MaterialUICore,
  axiomTokens,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { border, color, spacing } = axiomTokens;

export const PaymentModal = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    maxWidth: '666px',
    width: '100%',
  },
}));

export const DialogContent = styled(DSDialogContent)(({ theme }) => ({
  padding: `${spacing[1]} 0 0`,

  [theme.breakpoints.up('sm')]: {
    padding: `${spacing[1]} ${spacing[4]} ${spacing[4]}`,
  },
}));

export const DialogActions = styled(DSDialogActions)(({ theme }) => ({
  backgroundColor: color.branding[150],

  [theme.breakpoints.up('sm')]: {
    backgroundColor: color.background[1],
  },
}));

export const SummaryWrapper = styled('div')(({ theme }) => ({
  backgroundColor: '#f4f9fe',
  borderColor: color.branding[160],
  marginTop: spacing[4],
  padding: spacing[4],
  flex: 1,

  [theme.breakpoints.up('sm')]: {
    border: `${border.width.xs} solid ${color.branding[150]}`,
    borderRadius: border.radius.md,
    flex: 0,
  },
}));

export const WrapperTurnstile = styled('div')(({ theme }) => ({
  [theme.breakpoints.down(600)]: {
    marginTop: spacing[4],
    marginBottom: spacing[4],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `0 ${spacing[6]}`,
  },
  [theme.breakpoints.down(400)]: {
    padding: `0 ${spacing[3]}`,
  },
  [theme.breakpoints.down(320)]: {
    padding: `0 ${spacing[1]}`,
  },
}));
